import React from 'react'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { grey } from '@mui/material/colors'

interface Props {
  icon?: React.ReactNode
  parentItemText: string
  subItem?: boolean
  selectedID?: string
  collapseID?: string
  handleCollapse?: (ID?: string) => void
}

export const CollapseableMenuItem = ({
  parentItemText,
  icon,
  children,
  subItem = false,
  selectedID,
  collapseID,
  handleCollapse
}: React.PropsWithChildren<Props>) => {
  const [openCollapseSubItem, setOpenCollapseSubItem] = React.useState(false)
  const subItemStyling = subItem && {
    pl: 4,
    py: 0.5,
    color: `${grey[400]}`,
    '&:hover, &.active': { backgroundColor: grey[800], color: `${grey[100]}` }
  }

  const open = subItem ? openCollapseSubItem : selectedID === collapseID
  const handleSubItemCollapse = () => {
    if (subItem) {
      setOpenCollapseSubItem(!open)
    } else {
      handleCollapse && handleCollapse(collapseID)
    }
  }

  return (
    <>
      <ListItemButton
        onClick={handleSubItemCollapse}
        sx={{
          border: `1px solid ${grey[800]}`,
          borderWidth: '0 0 1px 0',
          color: theme => theme.palette.getContrastText(theme.palette.common.black),
          ...subItemStyling
        }}
      >
        {icon && <ListItemIcon sx={{ color: theme => theme.palette.getContrastText(theme.palette.common.black) }}>{icon}</ListItemIcon>}
        <ListItemText primary={parentItemText} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout='auto'>
        <List component='div' disablePadding sx={{ color: theme => theme.palette.getContrastText(theme.palette.common.black) }}>
          {children}
        </List>
      </Collapse>
    </>
  )
}
